import Moment from "moment";

export function tsFormat(ts) {
  return Moment(ts).format("YYYY-MM-DD HH:mm:ss");
}

export function addTsFormat(ts) {
  return Moment(ts)
    .add(1, "d")
    .utcOffset(-8)
    .format("YYYY-MM-DD HH:mm:ss");
}

export function tmFormat(ts) {
  return Moment(ts).format("YYYY-MM-DD HH:mm");
}

export function dtFormat(dt) {
  return Moment(dt).format("YYYY-MM-DD");
}
export function dmFormat(dt) {
  return Moment(dt).format("YYYY-MM-01");
}
export function curWeekRange() {
  let dateRange = new Array();
  let daysToMonday = new Date().getDay() - 6;
  let mondayOfTheWeek = Moment().add(daysToMonday, "days");
  dateRange.push(mondayOfTheWeek);
  let daysToSunday = 7 - new Date().getDay();
  if (daysToSunday == 7) {
    daysToSunday = 0;
  }
  let sundayOfTheWeek = Moment().add(daysToSunday, "days");
  dateRange.push(sundayOfTheWeek);
  return dateRange;
}

export function curMonthRange() {
  let today = new Date();
  let curYear = today.getFullYear();
  let curMonth = today.getMonth() + 1;
  if (curMonth < 10) {
    curMonth = "0" + curMonth;
  }
  let dateRange = new Array();
  let startStr = curYear + "-" + curMonth + "-01";
  let startOfTheMonth = Moment(startStr);
  dateRange.push(startOfTheMonth);
  let endOfTheMonth = startOfTheMonth
    .clone()
    .add(1, "month")
    .add(-1, "day");
  dateRange.push(endOfTheMonth);
  return dateRange;
}

export function curYearRange() {
  let curYear = new Date().getFullYear();
  let dateRange = new Array();
  dateRange.push(Moment(curYear + "-01-01"));
  dateRange.push(Moment(curYear + "-12-31"));
  return dateRange;
}
